class AANDialog {
	static openDialog(dialogId: string): void {
		const dialog = document.getElementById(dialogId);

		if(!dialog) {
			return;
		}
		// Not all browsers support the dialog element yet. as a result TypeScrupt doesn't recognize it.
		// We are polyfilling it so this will make TypeScript ignore the call.
		(dialog as any).showModal();
		// When displaying the login dialog, disable scrolling on the main body element,
		// not having this causes mobile browsers to get confused as to what element should be scrolled.
		document.body.style.overflow = "hidden";

		dialog.addEventListener("close", () => {
			document.body.style.overflow = "";
		});
	};

	init() {
		const dialogs = Array.from(document.querySelectorAll("dialog")) as HTMLDialogElement[];

		if (!dialogs || dialogs.length === 0) {
			return;
		}

		dialogs.forEach(dialog => {
			const closeButton = dialog.querySelector(".btn-close");

			closeButton?.addEventListener("click", event => {
				// Not all browsers support the dialog element yet. as a result TypeScrupt doesn't recognize it.
				// We are polyfilling it so this will make TypeScript ignore the call.
				(dialog as any).close();
				event.preventDefault();
				event.stopPropagation();
			});

			// Close the dialog when the backdrop is clicked.
			dialog.addEventListener("click", function (event) {
				const rect = dialog.getBoundingClientRect();
				const isInDialog = (rect.top <= event.clientY && event.clientY <= rect.top + rect.height
					&& rect.left <= event.clientX && event.clientX <= rect.left + rect.width);

				if (!isInDialog && !(event.target instanceof HTMLButtonElement)) {
					// Not all browsers support the dialog element yet. as a result TypeScrupt doesn't recognize it.
					// We are polyfilling it so this will make TypeScript ignore the call.
					(dialog as any).close();
				}
			});
		});
	}
}

// allow AanDialog to be accessable outside of our scripts.
(window as any).AANDialog = AANDialog;
document.addEventListener("DOMContentLoaded", () => {
	const dialogs = new AANDialog();

	dialogs.init();
});
